.container {
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  height: 100%;
}

.table {
  width: 100%;
  border-spacing: 0;

  /*
   * Typography, borders and padding come from `ListViewHeader`, whose rules are scoped as
   * `th` descendants — hence the `.table th` prefix here, so the column widths win.
   * Every column hugs its content except the email one, which takes the slack so the
   * actions stay pinned to the right edge.
   */
  th.headerCell {
    width: 1%;
    vertical-align: middle;

    &:nth-child(3) {
      width: 100%;
    }
  }
}
